import { render, staticRenderFns } from "./RecaptchaComponent.vue?vue&type=template&id=1188f45c"
import script from "./RecaptchaComponent.vue?vue&type=script&lang=ts"
export * from "./RecaptchaComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports